var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.05493C13.2525 4.80743 10.74 4.67993 8.235 4.67993C6.75 4.67993 5.265 4.75493 3.78 4.90493L2.25 5.05493",
    stroke: "#BA4831",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 4.29732L6.54 3.31482C6.66 2.60232 6.75 2.06982 8.0175 2.06982H9.9825C11.25 2.06982 11.3475 2.63232 11.46 3.32232L11.625 4.29732",
    stroke: "#BA4831",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1375 7.4248L13.65 14.9773C13.5675 16.1548 13.5 17.0698 11.4075 17.0698H6.59255C4.50005 17.0698 4.43255 16.1548 4.35005 14.9773L3.86255 7.4248",
    stroke: "#BA4831",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74756 12.9448H10.2451",
    stroke: "#BA4831",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 9.94482H10.875",
    stroke: "#BA4831",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash1);
export default __webpack_public_path__ + "static/media/trash1.9b62d50a62ee69c38d0d5bd9ee5a9b7c.svg";
export { ForwardRef as ReactComponent };